export const PRIVACY_POLICY_URL = "https://www.cincel.digital/aviso-de-privacidad/";

export const TERMS_AND_CONDITIONS_URL = "https://www.cincel.digital/terminos-y-condiciones/";
